var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-nickname"},[(_vm.showAchievement)?_c('image-a-level',{attrs:{"alevel":_vm.alevel,"type":"web"}}):_vm._e(),_c('p',{style:({ color: _vm.color }),attrs:{"title":_vm.nickname},domProps:{"innerHTML":_vm._s(_vm.nickname)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }